module.exports = __webpack_public_path__ + "media/images/flags/32/Solomon-Islands-b95061faf507c4fac9f2712c97a4fbf2.png";